import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Download } from "@mui/icons-material";
import CircularProgress from "@mui/material/CircularProgress";
const DownloadUserData = ({ btnHandler, buttonName, isLoading }) => {
  const { t } = useTranslation();

  return (
    <button
      className="parentbtn"
      onClick={() => {
        btnHandler();
      }}
      disabled={isLoading}
    >
      {isLoading ? (
        <CircularProgress size={18} style={{ color: "white" }} />
      ) : (
        <Download style={{ fill: "white", width: "18px", height: "18px" }} />
      )}
      &nbsp;&nbsp;{buttonName}
    </button>
  );
};

export default DownloadUserData;
